<template>
  <b-card border-variant="warning">
    <LineChartGenerator
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
  </b-card>
</template>

<script>
import { Line as LineChartGenerator } from "vue-chartjs/legacy";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
);

export default {
  name: "ChartConstantes",

  components: {
    LineChartGenerator,
  },


  props: {
    tableConstantes: { type: Array, default: () => [] },
    signosCita: { type: Array, default: () => [] },
    fechasCitas: { type: Array, default: () => [] },
    edadesCitas: { type: Array, default: () => [] },

    chartId: {
      type: String,
      default: "line-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 200,
    },
    height: {
      type: Number,
      default: 220,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
  },
  created() {
   
  },
  data() {
    return {
      espediatrico: false,
      chartData: {
        datasets: [
          {
            label: "PULSO",
            backgroundColor: "#F54F0B",
            data: [],
          },
          {
            label: "TEMPERATURA",
            backgroundColor: "#016FF5",
            data: [],
          },
        ],
      },

      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,

        scales: {
          y: {
            beginAtZero: false, // Comienza el eje Y desde 0
          
            ticks: {
              stepSize: 1, // Distancia entre los valores del eje Y
            },

            grid: {
              display: true,
              color: "rgba(0, 0, 0, 0.1)", // Color de la cuadrícula
            },

            title: {
              display: true,
              text: "VALORES", // Título del eje Y
            },
          },
          x: {
            grid: {
              display: true, // Oculta la cuadrícula del eje X
            },
          },
        },
      },
    };
  },

  watch: {
    tableConstantes: {
      deep: true,
      inmediate: true,

      handler(newValue) {
        if (newValue) {
          const pulso = [];
          const temperatura = [];
          const horas = []
          newValue.forEach((element) => {
            pulso.push(element.pulso);
            temperatura.push(element.temperatura);
            horas.push(element.hora);
            
          });
          this.chartData.labels = horas
          this.chartData.datasets = this.chartData.datasets.map(dataset => {
            if (dataset.label === "PULSO") dataset.data = pulso; // Asigna el nuevo valor a la propiedad 'data'
            
            if (dataset.label === "TEMPERATURA") dataset.data = temperatura; // Asigna el nuevo valor a la propiedad 'data'
            
            return dataset;
          });

         
        }
      },
    },
  },
};
</script>

